export interface IArchiveUpload {
    file: File;
    name: string;
    isBasic?: boolean;

    skip?: boolean;
    updateArchive?: boolean;

    state: ArchiveUploadState;
}

export enum ArchiveUploadState {
    NEW = 'new',
    EXISTING = 'existing',
    EXISTING_WITH_SAME_PERMISSIONS = 'existing with same permissions'
}

export interface IBulkArchiveUpload {
    archives: IArchiveUpload[];
    permissions: string[][];
}
